import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ag-grid-overlay-loading',
  templateUrl: './ag-grid-overlay-loading.component.html',
  styleUrls: ['./ag-grid-overlay-loading.component.scss']
})
export class AgGridOverlayLoadingComponent implements OnInit {
  public params: any;

  constructor() { }

  ngOnInit(): void {
  }

  agInit(params): void {
    this.params = params;
  }

}
